import { useEffect } from "react";

import useMySPHLightbox from "./useMySPHLightbox";

const useSessionRefresh = () => {
  const { lightbox } = useMySPHLightbox();

  useEffect(() => {
    if (typeof window === "undefined" || !lightbox) return;

    const url = new URL(window.location.href);
    const sessionRefresh = url.searchParams.get("session-refresh");

    // Explicit allow-list check (important for CodeQL)
    if (sessionRefresh !== "1") return;

    // Remove the parameter safely
    url.searchParams.delete("session-refresh");

    // Update browser URL without triggering navigation
    window.history.replaceState({}, "", url.toString());

    // Redirect target is fixed & trusted
    lightbox.authWithRedirect();
  }, [lightbox]);
};

export default useSessionRefresh;
